export const genArray = (element_num) => {
  return Array.from({ length: element_num }, (_, i) => i + 1);
};
